import React from 'react';

function toSafeNumber(value, fallback) {
  var n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

export default function ReportWidgetEdit({ selectedWidget, onWidgetChange }) {
  if (!selectedWidget) {
    return <div className="re-editor-empty">Select a widget to edit.</div>;
  }

  var patchWidget = function patchWidget(fieldName, value) {
    if (!onWidgetChange) {
      return;
    }

    onWidgetChange(selectedWidget.id, {
      [fieldName]: value
    });
  };

  return (
    <div className="re-editor-panel">
      <h3>Widget</h3>
      <label>
        Header
        <input
          value={selectedWidget.headerLabel || ''}
          onChange={function onChange(event) {
            patchWidget('headerLabel', event.target.value);
          }}
        />
      </label>
      <label>
        Subheader
        <input
          value={selectedWidget.subHeaderLabel || ''}
          onChange={function onChange(event) {
            patchWidget('subHeaderLabel', event.target.value);
          }}
        />
      </label>
      <label>
        X
        <input
          type="number"
          min="1"
          value={selectedWidget.xCoordinate}
          onChange={function onChange(event) {
            patchWidget('xCoordinate', toSafeNumber(event.target.value, selectedWidget.xCoordinate));
          }}
        />
      </label>
      <label>
        Y
        <input
          type="number"
          min="1"
          value={selectedWidget.yCoordinate}
          onChange={function onChange(event) {
            patchWidget('yCoordinate', toSafeNumber(event.target.value, selectedWidget.yCoordinate));
          }}
        />
      </label>
      <label>
        Width
        <input
          type="number"
          min="1"
          value={selectedWidget.width}
          onChange={function onChange(event) {
            patchWidget('width', toSafeNumber(event.target.value, selectedWidget.width));
          }}
        />
      </label>
      <label>
        Height
        <input
          type="number"
          min="1"
          value={selectedWidget.height}
          onChange={function onChange(event) {
            patchWidget('height', toSafeNumber(event.target.value, selectedWidget.height));
          }}
        />
      </label>
    </div>
  );
}
